<template>
  <LoaderWrapper ref="loader" class="d-flex float-start">
  <div>
    <div v-if="device" class="d-flex flex-row align-items-center">
      <div v-if="isAdmin || isOperator" class="me-2">
        <button v-if="!device.blockedAt" v-b-tooltip.hover :title="helper.trans('trader.status.active')" @click.prevent="toggleBlock(device, true)" class="btn btn-sm btn-outline-success"><i class="fa fa-circle-play"></i></button>
        <button v-else v-b-tooltip.hover :title="helper.trans('labels.traffic_blocked')" @click.prevent="toggleBlock(device, false)" class="btn btn-sm btn-outline-warning"><i class="fa fa-circle-pause"></i></button>
      </div>
      <div class="d-flex flex-column">
        <div>
          <i v-b-tooltip.hover.html :title="title" style="font-size: 70%" :class="{'text-success': device.status === 'online', 'text-danger': device.status === 'offline'}" class="fa-solid fa-circle"></i>
          <span class="ms-1">{{ device.name }}</span>
          <copy-button class="ms-1" :value="copyTitle"></copy-button>
        </div>
        <div v-if="showId">
          <small class="text-secondary" v-b-tooltip.hover :title="device.id">{{ device.id.substr(0, 8) }}</small> <copy-button :value="device.id"></copy-button>
        </div>
        <small class="text-danger" v-if="device?.deletedAt !== null">{{helper.trans('labels.deleted')}}</small>
      </div>
    </div>
    <div v-else>n/a</div>
  </div>
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import APIClient from "@/service/APIClient";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import {dateHelper} from "@/service/DateHelper";
import CopyButton from "@/components/CopyButton.vue";
import {useStore} from "vuex";
import LoaderWrapper from "@/components/LoaderWrapper.vue";

const api = new APIClient()
export default defineComponent({
  name: "DeviceLabel",
  emits: ['device:updated'],
  components: {
    CopyButton,
    LoaderWrapper
  },
  props: {
    device: {
      type: Object as PropType<TraderDeviceDTO|null>,
      default: null
    } as Prop<TraderDeviceDTO|null>,
    showId: Boolean
  },
  setup(props, {emit}) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const store = useStore();

    const titleParts = computed(() => {
      if (!props.device) {
        return [];
      }

      const device = props.device;

      return [
        device.name,
        helper.trans(`labels.${device.status}_since`, {date: device.statusUpdatedAt ? dateHelper.format(device.statusUpdatedAt) : 'n/a'}),
        `${helper.trans('labels.manufacturer')}: ${device.manufacturer ?? 'n/a'}`,
        `${helper.trans('labels.model')}: ${device.model ?? 'n/a'}`,
        `${helper.trans('labels.app_version')}: ${device.appVersion ?? 'n/a'}`,
        `${helper.trans('labels.android_version')}: ${device.androidVersion ?? 'n/a'}`,
      ]
    });

    const title = computed(() => {
      if (!props.device) {
        return '';
      }

      let items = [];
      for (const part of titleParts?.value) {
        items.push(`<span>${part}</span>`);
      }


      return '<div class="text-start d-flex flex-column">' + items.join('') + '</div>';
    })

    const copyTitle = computed(() => {
      if (!props.device) {
        return '';
      }

      return titleParts?.value.join('\n')
    })

    const toggleBlock = async (device: TraderDeviceDTO, blocked: boolean) => {
      loader.value?.show()
      try {
        const deviceDTO = await api.deviceToggleBlock(device.id, blocked ? 'block' : 'unblock')
        emit('device:updated', deviceDTO)
      } finally {
        loader.value?.hide()
      }
    }


    return {
      helper,
      title,
      copyTitle,
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      loader,
      toggleBlock
    }
  }
})
</script>
